// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4p-6";
export var headerCell = "_4p-2";
export var rowWrapper = "_4p-4";
export var stickyAggregationCell = "_4p-a";
export var stickyAggregationRow = "_4p-7";
export var stickyColumnCell = "_4p-9";
export var stickyColumnHeaderCell = "_4p-8";
export var table = "_4p-1";
export var virtualRowWrapper = "_4p-5";
export var virtualTableContainer = "_4p-0";
export var white = "_4p-3";